if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        RichText,
        InspectorControls,
        MediaUpload,
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        IconButton, 
        TextControl,
        TextareaControl
    } = window.wp.components;

    registerBlockType('custom-gutenberg/card-double', {
        // built-in attributes
        title: 'Card Double',
        description: 'Custom Card Double',
        icon: '',
        category: 'custom-cards',
        example: {},

        // custom attributes
        attributes: {
            link_1: {
                type: 'string',
                default: '',
            },
            link_2: {
                type: 'string',
                default: '',
            },
            image_1: {
                type: 'string',
                default: ''
            }, 
            image_2: {
                type: 'string',
                default: ''
            }, 
            alt_1: {
                type: 'string',
                default: ''
            }, 
            alt_2: {
                type: 'string',
                default: ''
            }, 
            tag_1: {
                type: 'string',
                default: ''
            },
            tag_2: {
                type: 'string',
                default: ''
            },
            title_1: {
                type: 'string',
                default: ''
            },
            title_2: {
                type: 'string',
                default: ''
            },
            description_1: {
                type: 'string',
                default: ''
            },
            description_2: {
                type: 'string',
                default: ''
            },
            viewMore_1: {
                type: 'string',
                default: 'Saznajte više'
            },
            viewMore_2: {
                type: 'string',
                default: 'Saznajte više'
            },
        },

        // built-in functions
        edit({ attributes, setAttributes }) {

            const {
                link_1,
                link_2,
                image_1,
                image_2,
                alt_1,
                alt_2,
                tag_1,
                tag_2,
                title_1,
                title_2,
                description_1,
                description_2,
                viewMore_1,
                viewMore_2
            } = attributes;

            // custom functions
            function onLinkChange_1 (link_1) {
                setAttributes({link_1: link_1});
            };
            function onLinkChange_2 (link_2) {
                setAttributes({link_2: link_2});
            };

            function onSelectImage_1 (image_1) {
                setAttributes({image_1: image_1.sizes.full.url});
            }
            function onSelectImage_2 (image_2) {
                setAttributes({image_2: image_2.sizes.full.url});
            }

            function onAltChange_1 (alt_1) {
                setAttributes({alt_1: alt_1});
            };
            function onAltChange_2 (alt_2) {
                setAttributes({alt_2: alt_2});
            };

            function onTagChange_1(tag_1) {
                setAttributes({tag_1: tag_1});
            }
            function onTagChange_2(tag_2) {
                setAttributes({tag_2: tag_2});
            }

            function onTitleChange_1(title_1) {
                setAttributes({title_1: title_1});
            }
            function onTitleChange_2(title_2) {
                setAttributes({title_2: title_2});
            }

            function onDescriptionChange_1(description_1) {
                setAttributes({description_1: description_1});
            }
            function onDescriptionChange_2(description_2) {
                setAttributes({description_2: description_2});
            }

            function onViewMoreChange_1(viewMore_1) {
                setAttributes({viewMore_1: viewMore_1});
            }
            function onViewMoreChange_2(viewMore_2) {
                setAttributes({viewMore_2: viewMore_2});
            }

            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Card 1' }>
                        <MediaUpload 
                            onSelect={ onSelectImage_1 }
                            type="image"
                            value={ image_1 } 
                            render={ ( { open } ) => (
                                <IconButton
                                    onClick={ open }
                                    icon="upload"
                                    classNames="editor-media-placeholder__button is-button is-default is-large">
                                    Select Background Image
                                </IconButton>
                            ) } />
                        <br />
                        <p><strong>Alt image:</strong></p>
                        <TextControl value={ alt_1 } onChange={ onAltChange_1 }></TextControl>
                        <br />
                        <p><strong>Enter url: (ex: /putovanja)</strong></p>
                        <TextControl value={ link_1 } onChange={ onLinkChange_1 }></TextControl>
                        <br />
                        <p><strong>Oznaka</strong></p>
                        <TextControl value={ tag_1 } onChange={ onTagChange_1 }></TextControl>
                        <br />
                        <p><strong>Title</strong></p>
                        <TextControl value={ title_1 } onChange={ onTitleChange_1 }></TextControl>
                        <br />
                        <p><strong>Description</strong></p>
                        <TextareaControl value={ description_1 } onChange={ onDescriptionChange_1 }></TextareaControl>
                        <br />
                        <p><strong>Button</strong></p>
                        <TextControl value={ viewMore_1 } onChange={ onViewMoreChange_1 }></TextControl>
                    </PanelBody>

                    <PanelBody title={ 'Card 2' }>
                        <MediaUpload 
                            onSelect={ onSelectImage_2 }
                            type="image"
                            value={ image_2 } 
                            render={ ( { open } ) => (
                                <IconButton
                                    onClick={ open }
                                    icon="upload"
                                    classNames="editor-media-placeholder__button is-button is-default is-large">
                                    Select Background Image
                                </IconButton>
                            ) } />
                        <br />
                        <p><strong>Alt image:</strong></p>
                        <TextControl value={ alt_2 } onChange={ onAltChange_2 }></TextControl>
                        <br />
                        <p><strong>Enter url: (ex: /putovanja)</strong></p>
                        <TextControl value={ link_2 } onChange={ onLinkChange_2 }></TextControl>
                        <br />
                        <p><strong>Oznaka</strong></p>
                        <TextControl value={ tag_2 } onChange={ onTagChange_2 }></TextControl>
                        <br />
                        <p><strong>Title</strong></p>
                        <TextControl value={ title_2 } onChange={ onTitleChange_2 }></TextControl>
                        <br />
                        <p><strong>Description</strong></p>
                        <TextareaControl value={ description_2 } onChange={ onDescriptionChange_2 }></TextareaControl>
                        <br />
                        <p><strong>Button</strong></p>
                        <TextControl value={ viewMore_2 } onChange={ onViewMoreChange_2 }></TextControl>
                    </PanelBody>
                </InspectorControls>
                ,
                <div class="card-double rounded bg-white shadow overflow-hidden">
                    <div class="row g-0">
                        <div class="col-lg border-end-primary d-flex flex-column">
                            <a class="d-flex flex-1 text-decoration-none">
                                <div class="row flex-1 g-0">
                                    <div class="col-lg-5">
                                        <img class="cover-image w-100 h-100" src={ image_1 } alt={ alt_1 } />
                                    </div>
                                    <div class="col-lg d-flex flex-column">
                                        <div class="p-4 flex-1 d-flex flex-column justify-content-between">
                                            <div>
                                                <div class="d-inline-block bg-secondary text-white rounded-pill fw-bold px-3 py-1 mb-3 small">
                                                    <RichText 
                                                        key="editable" 
                                                        tagName="span"
                                                        placeholder="TAG" 
                                                        value={ tag_1 }
                                                        onChange={ onTagChange_1 } />
                                                </div>
                                                <RichText 
                                                    key="editable" 
                                                    tagName="h3"
                                                    className="h4 mb-3"
                                                    placeholder="Title" 
                                                    value={ title_1 }
                                                    onChange={ onTitleChange_1 } />
                                                <RichText 
                                                    key="editable" 
                                                    tagName="p" 
                                                    class=""
                                                    placeholder="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nec ornare sapien eu est sociis phasellus hendrerit quam semper." 
                                                    value={ description_1 }
                                                    onChange={ onDescriptionChange_1 } />
                                            </div>
                                            <div>
                                                <button class="btn btn-white fw-bold text-primary p-0 mb-2">
                                                    <RichText 
                                                        key="editable" 
                                                        tagName="span"
                                                        placeholder="Saznajte više" 
                                                        value={ viewMore_1 }
                                                        onChange={ onViewMoreChange_1 } />
                                                    <i class="las la-arrow-right la-lg ms-2"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="col-lg d-flex flex-column">
                            <a class="d-flex flex-1 text-decoration-none">
                                <div class="row flex-1 g-0">
                                    <div class="col-lg order-1 order-lg-0 d-flex flex-column">
                                        <div class="p-4 flex-1 d-flex flex-column justify-content-between">
                                            <div class="mb-4">
                                                <div class="d-inline-block bg-primary text-white rounded-pill fw-bold px-3 py-1 mb-3 small">
                                                    <RichText 
                                                        key="editable" 
                                                        tagName="span"
                                                        placeholder="TAG" 
                                                        value={ tag_2 }
                                                        onChange={ onTagChange_2 } />
                                                </div>
                                                <RichText 
                                                    key="editable" 
                                                    tagName="h3"
                                                    className="h4 mb-3"
                                                    placeholder="Title" 
                                                    value={ title_2 }
                                                    onChange={ onTitleChange_2 } />
                                                <RichText 
                                                    key="editable" 
                                                    tagName="p" 
                                                    class=""
                                                    placeholder="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nec ornare sapien eu est sociis phasellus hendrerit quam semper." 
                                                    value={ description_2 }
                                                    onChange={ onDescriptionChange_2 } />
                                            </div>
                        
                                            <div>
                                                <button class="btn btn-white fw-bold text-primary p-0 mb-2">
                                                    <RichText 
                                                        key="editable" 
                                                        tagName="span"
                                                        placeholder="Saznajte više" 
                                                        value={ viewMore_2 }
                                                        onChange={ onViewMoreChange_2 } />
                                                    <i class="las la-arrow-right la-lg ms-2"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-5">
                                        <img class="cover-image w-100 h-100" src={ image_2 } alt={ alt_2 } />
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            ]
            );
        },

        save({ attributes }) {

            const {
                link_1,
                link_2,
                image_1,
                image_2,
                alt_1,
                alt_2,
                tag_1,
                tag_2,
                title_1,
                title_2,
                description_1,
                description_2,
                viewMore_1,
                viewMore_2
            } = attributes;

            return (
                <div class="card-double rounded bg-white shadow overflow-hidden">
                    <div class="row g-0">
                        <div class="col-lg border-end-primary d-flex flex-column">
                            <a href={ link_1 } class="d-flex flex-1 text-decoration-none">
                                <div class="row flex-1 g-0">
                                    <div class="col-lg-5">
                                        <img class="lozad cover-image w-100 h-100" data-src={ image_1 } alt={ alt_1 } />
                                    </div>
                                    <div class="col-lg d-flex flex-column">
                                        <div class="p-4 flex-1 d-flex flex-column justify-content-between">
                                            <div>
                                                <div class="d-inline-block bg-secondary text-white rounded-pill fw-bold px-3 py-1 mb-3 small">
                                                    { tag_1 }
                                                </div>
                                                <h3 class="h4 mb-3">{ title_1 }</h3>
                                                <RichText.Content 
                                                    tagName="p" 
                                                    value={ description_1 } />
                                            </div>
                                            <div>
                                                <button class="btn btn-white fw-bold text-primary p-0 mb-2">
                                                    { viewMore_1 }
                                                    <i class="las la-arrow-right la-lg ms-2"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="col-lg d-flex flex-column">
                            <a href={ link_2 } class="d-flex flex-1 text-decoration-none">
                                <div class="row flex-1 g-0">
                                    <div class="col-lg order-1 order-lg-0 d-flex flex-column">
                                        <div class="p-4 flex-1 d-flex flex-column justify-content-between">
                                            <div class="mb-4">
                                                <div class="d-inline-block bg-primary text-white rounded-pill fw-bold px-3 py-1 mb-3 small">
                                                    { tag_2 }
                                                </div>
                                                <h3 class="h4 mb-3">{ title_2 }</h3>
                                                <RichText.Content 
                                                    tagName="p" 
                                                    value={ description_2 } />
                                            </div>
                        
                                            <div>
                                                <button class="btn btn-white fw-bold text-primary p-0 mb-2">
                                                    { viewMore_2 }
                                                    <i class="las la-arrow-right la-lg ms-2"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-5">
                                        <img class="lozad cover-image w-100 h-100" data-src={ image_2 } alt={ alt_2 } />
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            );
        },
    });
}
